import React from 'react';
import RouterTestContainer from './Router';
const App= (props)=>{
    return <RouterTestContainer />;
};

export default App;